export default {
  PLAYER: 'player',
  FAN: 'fan',
  COACH: 'coach',
  SUPER_ADMIN: 'super admin',
  SPORT_ADMIN: 'sport admin',
  ORGANIZATION_ADMIN: 'organization admin'
}
